import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { ErrorBox } from '../../../../../shared/components/ui/ErrorBox'
import { PlaceholderBox } from '../../../../../shared/components/ui/PlaceholderBox'
import { customersProxy, CustomerTableColumnsEnum } from '../../../../../shared/proxies/customersProxy'
import { CustomerTableHeader } from './CustomerTableHeader'
import { CustomerTableRows } from './CustomerTableRows'
import { CustomerTableFooter } from './CustomerTableFooter'

export function CustomerTable (): ReactElement {
  const { apiCall } = useSnapshot(customersProxy)
  return (
    <div className="w-full">
      <PlaceholderBox loading={apiCall.loading} rows={20} additionalClasses="p-2">
        <ErrorBox error={apiCall.error}>
          <table className="w-full">
            <thead className="text-left">
              <tr>
                <CustomerTableHeader title="Customer ID" width={15} sortColumn={CustomerTableColumnsEnum.Id} />
                <CustomerTableHeader title="Company" width={15} sortColumn={CustomerTableColumnsEnum.CompanyName} />
                <CustomerTableHeader title="Name" width={20} sortColumn={CustomerTableColumnsEnum.Name} />
                <CustomerTableHeader title="Address" width={30} sortColumn={CustomerTableColumnsEnum.Address} />
                <CustomerTableHeader title="Email" width={20} sortColumn={CustomerTableColumnsEnum.Email} />
              </tr>
            </thead>
            <tbody>
              <CustomerTableRows />
            </tbody>
          </table>
          <hr />
          <CustomerTableFooter />
        </ErrorBox>
      </PlaceholderBox>
    </div>

  )
}
